@let corporateDesign = corporateDesignService.corporateDesign();
@let subscriptionConfig = subscription.subscriptionConfig();
<aw-shopping-cart-headline
  [relationType]="
    ERelationType.subscriptionShoppingCartLabel
  "></aw-shopping-cart-headline>
<aw-ticket-frame
  [hasHeadline]="true"
  [upperTicketElement]="upper"
  [upperSegments]="subscriptionConfig ? [subscriptionConfig] : []"
  [style]="{
    color: corporateDesignService.fontColor(),
  }"
  [styling]="{
    borderWidth: '1px',
    borderColor: corporateDesignService.primaryBorderColor(),
    backgroundColor: corporateDesignService.isDarkModeActive()
      ? corporateDesign.colorAdmixtures.dark_surface_01
      : 'white',
  }">
  <ng-template #upper let-data="data" let-index="index">
    @if (subscriptionConfig) {
      <span class="text-2xl">{{ subscriptionConfig.name }}</span>
    }
  </ng-template>
  <div lower>
    @if (subscriptionConfig) {
      <div class="flex flex-col gap-3">
        <span>{{
          textStore.texts()
            | filterTexts
              : ERelationType.subscriptionShoppingCartHint
              : EEntityType.shoppingCart
            | language
        }}</span>
        <aw-button
          type="submit"
          [id]="'subscription-shopping-cart-continue'"
          (click)="onButtonClick.emit()"
          >{{
            textStore.texts()
              | filterTexts: ERelationType.continue : EEntityType.generic
              | language
          }}</aw-button
        >
      </div>
    } @else {
      <ng-container
        *ngTemplateOutlet="emptyShoppingCartTemplate"></ng-container>
    }
  </div>
</aw-ticket-frame>

<ng-template #emptyShoppingCartTemplate>
  <aw-shopping-cart-empty></aw-shopping-cart-empty>
</ng-template>
